"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _uiKit = require("@devsta/ui-kit");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

require("../styles/_related-outputs.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function goToOutputPage(output, history, videoId) {
  return function () {
    if (output.status.name === 'APPROVED') {
      return void history.push("/complete/".concat(videoId, "/").concat(output.outputId));
    }

    history.rootPush("/review/".concat(videoId, "/").concat(output.outputId));
  };
}

function RelatedOutputs(_ref) {
  var outputs = _ref.outputs,
      currentOutput = _ref.currentOutput,
      videoName = _ref.videoName,
      history = _ref.history,
      videoId = _ref.videoId;

  if (outputs.length < 2) {
    return null;
  }

  return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_uiKit.Accordion, {
      titles: ["Related Videos (".concat(outputs.length - 1, ")")]
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "related-outputs"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Carousel, null, outputs.filter(function (relatedOutput) {
      return currentOutput.outputId !== relatedOutput.outputId;
    }).map(function (relatedOutput) {
      var onClick = goToOutputPage(relatedOutput, history, videoId);
      var assetId = relatedOutput.versions[relatedOutput.versions.length - 1].assetId;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "related-outputs__output",
          role: "button",
          tabIndex: 0,
          onClick: onClick,
          key: relatedOutput.outputId,
          onKeyPress: (0, _onEnterPressed.default)({
            onClick: onClick
          })
        }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
          assetId: assetId,
          asset: !assetId ? {
            metaData: JSON.stringify({
              type: 'video/'
            })
          } : void 0,
          height: 130,
          width: 262,
          borderRadius: 6,
          darkMode: true
        }), /*#__PURE__*/_react.default.createElement("p", {
          className: "related-outputs__output__name"
        }, (0, _getVideoOutputName.default)(relatedOutput, videoName)))
      );
    })))))
  );
}

var _default = (0, _react.memo)(RelatedOutputs);

exports.default = _default;